<template>
  <canvas id="production-summary-chart" :style="{ maxWidth: maxWidth }"/>
</template>

<script>
import { Chart } from 'chart.js'
import { getChartColors } from '@/components/dashboard/ChartColors.js'
import { tonStringFromPounds } from '@/utils/NumericMutations.js'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductSummaryChart',

  props: {
    productSummary: {
      type: Array,
      required: true
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },

  data: () => ({
    chart: null
  }),

  mounted () {
    this.buildChart()
  },

  watch: {
    productSummary: {
      handler () {
        this.buildChart()
      },
      deep: true
    },
    useMetricTons: {
      handler () {
        this.buildChart()
      }
    }
  },

  computed: {
    ...mapGetters('settlements', ['useMetricTons'])
  },

  methods: {
    buildChart () {
      if (this.chart) {
        this.chart.destroy()
      }
      const chartElement = document.getElementById('production-summary-chart')
      this.chart = new Chart(chartElement, {
        type: 'doughnut',
        data: this.getChartData(this.productSummary),
        options: {
          plugins: {
            legend: { display: false }
          }
        }
      })
    },

    getChartData (productSummary) {
      const labels = productSummary.map((ps) => ps.productName)
      const weightInfo = productSummary.map((ps) =>
        parseFloat(tonStringFromPounds(ps.weight, 3, this.useMetricTons))
      )
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: getChartColors(labels.length),
            data: weightInfo
          }
        ]
      }
    }
  }
}
</script>
